import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable, throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';

@Injectable({
  providedIn: 'root'
})
export class FaqPublicService {

  faqs: any;
  urlPolicyListPage: any;

  constructor(private http: HttpClient) {
    this.urlPolicyListPage = `${environment.bffBaseUrl}/pages/faq-list`;
  }

  getallfaq(): Observable<any> {
    const urlBuilder = this.urlPolicyListPage;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

}
